import { Colors } from "./Colors"

const tags = {
    medium22: {
        fontFamily: "MassiliaMedium",
        size: '22px',
    },
    regularOblique18: {
        fontFamily: "MassiliaOblique",
        size: '18px',
    },
    bullet: {
        wrap: {
            mode: 'word',
            width: 700
        },
        x: 20

    },
    boldOblique: {
        fontFamily: "MassiliaBoldOblique",
        size: '32px',
    },

    small: {
        fontFamily: "MassiliaRegular",
        size: '35px',
    },
    boldSmall: {
        fontSize: "16px",
        fontFamily: "MassiliaMedium",
    }
}

export {
    tags
}